<mat-toolbar color="primary" *ngIf="!authService.isLoggedInPage()">
  <span>{{ 'TITLE' | translate }}</span>
  <span class="ts-icon"></span>
</mat-toolbar>
